var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"layout-default__header"},[_c('div',{staticClass:"layout-default__header__container"},[_c('RouterLink',{attrs:{"to":{
        name: 'home',
        params: {
          doc: _vm.$route.meta.docDefault,
          version: _vm.latestVersion
        }
      }}},[_c('img',{staticClass:"layout-default__header__logo",attrs:{"src":require("@/assets/images/playkids-learning-logo.png"),"alt":"Logo PlayKids Learning"}})]),_c('div',{staticClass:"layout-default__header__tray"},[(_vm.isDefaultView)?_c('RouterLink',{attrs:{"to":{
          name: 'home',
          params: {
            doc: 'privacy',
            version: 'center'
          }
        }}},[_vm._v(" "+_vm._s(_vm.$t('privacyLink'))+" ")]):_c('RouterLink',{attrs:{"to":{
          name: 'home',
          params: {
            doc: _vm.$route.meta.docDefault,
            version: _vm.latestVersion
          }
        }}},[_vm._v(" "+_vm._s(_vm.$t('privacyPolicy'))+" ")]),_c('DarkModeSwitcher'),_c('LangSwitcher')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }